import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbSchema, webPageSchema } from "@/lib/schema";

export const Route = createFileRoute("/security-disclaimer")({
  head: () => ({
    meta: [
      { title: "Security Disclaimer — Pal Stars" },
      { name: "description", content: "Security disclosure practices, vulnerability reporting and shared-responsibility notice for the Pal Stars fan wiki." },
      { property: "og:title", content: "Security Disclaimer — Pal Stars" },
      { property: "og:description", content: "Security disclosure, vulnerability reporting and shared responsibility for Pal Stars." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://palstars.com/security-disclaimer" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://palstars.com/security-disclaimer" }],
    scripts: [breadcrumbSchema([["Home", "/"], ["Security Disclaimer", "/security-disclaimer"]]), webPageSchema({ name: "Security Disclaimer", description: "Security disclosure practices, vulnerability reporting and shared-responsibility notice for Pal Stars.", path: "/security-disclaimer" })],
  }),
  component: SecurityPage,
});

function SecurityPage() {
  return (
    <article className="mx-auto max-w-3xl px-4 sm:px-6 py-12 prose prose-invert">
      <h1 className="text-3xl sm:text-4xl font-bold">Security Disclaimer</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        This page is maintained by the Pal Stars team to answer common security and privacy questions about the site.
        It describes enabled controls; it is not a certification.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-foreground">Shared responsibility</h2>
      <p className="mt-2">
        Pal Stars runs on managed cloud infrastructure. The hosting platform provides transport encryption,
        DDoS protection, and platform-level access controls. The Pal Stars team is responsible for site code,
        content moderation and contact-form handling. Visitors are responsible for keeping their own browsers
        and devices up to date.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-foreground">Data handling</h2>
      <ul className="mt-2 list-disc pl-6 space-y-1">
        <li>Traffic to palstars.com is served over HTTPS.</li>
        <li>Preferences (favorites, theme, history) stay in your browser's localStorage — we don't sync them.</li>
        <li>Contact-form messages are used only to respond to you.</li>
      </ul>

      <h2 className="mt-8 text-xl font-semibold text-foreground">No guarantees</h2>
      <p className="mt-2">
        No online service can be fully secure. Pal Stars does not claim compliance with any specific standard
        (SOC 2, ISO 27001, GDPR, HIPAA, PCI) and does not provide legal or security assurances. Use the site at
        your own risk.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-foreground">Reporting a vulnerability</h2>
      <p className="mt-2">
        If you discover a security issue that affects Pal Stars visitors, please report it privately through the
        contact page rather than posting publicly. We ask that you avoid testing that could disrupt the site or
        access other users' data. We appreciate responsible disclosure.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-foreground">Third parties</h2>
      <p className="mt-2">
        Embedded YouTube videos, Google Fonts and external guide links are governed by their own security and
        privacy policies. We do not control their infrastructure.
      </p>
    </article>
  );
}
